import api from './api';

/**
 * Demo Mode Service
 * Handles demo mode status and feature restrictions
 */

let demoStatus = null;

const demoService = {
  /**
   * Fetch and cache the demo status from the API
   */
  async getStatus() {
    if (demoStatus !== null) {
      return demoStatus;
    }
    
    try {
      const response = await api.get('/demo-status');
      demoStatus = response.data;
      return demoStatus;
    } catch (error) {
      console.error('Error fetching demo status:', error);
      return { demo_mode: false, restricted_features: [] };
    }
  },

  /**
   * Check if the app is running in demo mode
   */
  async isDemoMode() {
    const status = await this.getStatus();
    return status.demo_mode;
  },

  /**
   * Check if a specific feature is restricted
   */
  async isFeatureRestricted(feature) {
    const status = await this.getStatus();
    return status.demo_mode && status.restricted_features.includes(feature);
  },

  /**
   * Get the list of restricted features
   */
  async getRestrictedFeatures() {
    const status = await this.getStatus();
    return status.restricted_features || [];
  },

  /**
   * Clear the cached status (useful after login/logout)
   */
  clearCache() {
    demoStatus = null;
  }
};

export default demoService;

// Feature constants for easy reference
export const DEMO_FEATURES = {
  EMAIL_SEND: 'email_send',
  EMAIL_REPLY: 'email_reply',
  LEXOFFICE_SYNC: 'lexoffice_sync',
  LEXOFFICE_UPLOAD: 'lexoffice_upload',
  DATEV_EXPORT: 'datev_export',
  ASANA_SYNC: 'asana_sync'
};
